<template>
    <div v-if="!loading">
        <div class="header-actions">
            <CorpId />
            <CompassButton
                :label="$t.__('developerPage.Widgets.add_widget')"
                type="primary"
                class="ml-3"
                @click="createWidget"
            />
        </div>

        <!-- TABLE -->
        <el-table
            v-if="widgets.length"
            :data="widgets"
            :defaultSort="{ prop: 'name', order: 'ascending' }"
            border
        >
            <!-- NAME -->
            <el-table-column
                prop="name"
                :label="$t.__('common.labels.name')"
                width="200"
                sortable
                showOverflowTooltip
            >
            </el-table-column>

            <!-- WEBSITE -->
            <el-table-column :label="$t.__('common.labels.address')">
                <template #default="scope">
                    <a :href="scope.row.website" target="_blank" class="primary-50">{{
                        scope.row.website
                    }}</a>
                </template>
            </el-table-column>

            <!-- CODE TO INSERT -->
            <el-table-column :label="$t.__('developerPage.Widgets.code_to_insert')">
                <template #default="scope">
                    <el-input
                        v-model="scope.row.formatted_hash"
                        type="textarea"
                        :rows="4"
                        :readonly="true"
                    >
                    </el-input>
                </template>
            </el-table-column>

            <!-- ACTION -->
            <el-table-column fixed="right" :label="$t.__('common.labels.actions')" width="104">
                <template #default="scope">
                    <div class="flex-row">
                        <CompassIconButton
                            icon="settings"
                            type="tertiary"
                            @click="editWidget(scope.row.id)"
                        />
                        <CompassIconButton
                            icon="bin"
                            type="tertiary"
                            class="ml-2"
                            @click="deleteWidget(scope.row.id)"
                        />
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div v-else class="placeholder well">
            {{ $l10n.__("Vous ne disposez d'aucun formulaire actif") }}
        </div>
    </div>
    <preloader v-else :background="false" :display="true" />
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import CorpId from 'vcomponents/developerPage/CorpId.vue';

export default {
    components: {
        Preloader,
        LinkButton,
        CorpId,
    },
    data() {
        return {
            loading: true,
            widgets: [],
        };
    },
    created() {
        this.getWidgets()
            .then((widgets) => (this.widgets = widgets))
            .finally(() => (this.loading = false));
    },
    methods: {
        getWidgets() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/developer/widgets`, {}, (response) => {
                    resolve(response);
                });
            });
        },
        createWidget() {
            Snippet.prepareForm();
        },
        editWidget(id) {
            Snippet.prepareForm(id);
        },
        deleteWidget(id) {
            const widget = this.widgets.find((w) => w.id == id);
            Snippet.remove(id)
                .then(() => {
                    this.loading = true;
                    this.widgets = this.widgets.filter((w) => w.id !== id);
                    this.loading = false;
                    Push.success(this.$l10n.__('Widget "%s" supprimé', widget.name));
                })
                .catch((_) =>
                    Push.error(
                        this.$l10n.__('Erreur lors de la suppression du Widget "%s"', widget.name),
                    ),
                );
        },
    },
};
</script>
